module.exports = __webpack_public_path__ + "img/img1.cd68939b.png";